// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Dd5S","messages":"Chat_messages__3orv7","dateDivider":"Chat_dateDivider__1UqF0"};